import styled, { css } from 'styled-components';
import { getToken } from '@optimus-web/common';
import { Stack } from '@optimus-web/core';

export const CellDivider = styled.div<{
    headerElement?: boolean;
    selected?: boolean;
}>`
    flex: 1 1;
    border-top-width: ${getToken('borderWidth100')}px;
    border-top-style: solid;
    border-top-color: ${getToken('borderStaticSecondary')};

    ${({ headerElement }) =>
        headerElement &&
        css`
            border-top-width: ${getToken('borderWidth250')}px;
        `}
    ${({ selected }) =>
        selected &&
        css`
            border-top-color: ${getToken('paletteBasicsWhite')};
        `}
`;

export const ColoredStack = styled(Stack)<{ selected?: boolean }>`
    background-color: ${({ selected }) =>
        selected ? getToken('backgroundInteractiveSecondaryDefault') : 'transparent'};
`;
